var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Enroll"},[(!_vm.inTime)?_c('div',{staticClass:"panel"},[_c('no_access')],1):[(_vm.user.enrolled)?_c('div',{staticClass:"panel"},[_c('enrolled')],1):_c('div',{staticClass:"panel"},[_c('simple_enroll')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }